import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import Toggle from '@/components/common/Toggle/Toggle';
import styles from './no-further-billing.module.scss';

interface INoFurtherBillingToggleProps extends ICellRendererParams<ContractLine> {
}

export default function NoFurtherBillingToggle({ data, setValue }: INoFurtherBillingToggleProps) {
  const onChange = () => {
    const newValue = !Boolean(data?.noFurtherBilling);
    setValue?.(newValue);
  };

  return (
    <div className={styles.wrapper}>
      <Toggle
        id={data?.contractLineID!}
        isEnable={Boolean(data?.noFurtherBilling)}
        onChange={onChange}
      />
    </div>
  );
}
